import { AuthAction, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT } from '../actions/auth';
import { isLoggedIn } from '../services/auth';
import { AuthState } from './typings';

export const initialState: Readonly<AuthState> = Object.freeze({
  loggedIn: isLoggedIn(),
  loginFailure: false,
});

function auth(state: AuthState = initialState, action: AuthAction): AuthState {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return { ...state, loggedIn: true, loginFailure: false };
    case LOGIN_FAILURE:
      return { ...state, loggedIn: false, loginFailure: true };
    case LOGOUT:
      return { ...state, loggedIn: false, loginFailure: false };
    default:
      return state;
  }
}

export default auth;
